module.exports = __webpack_public_path__ + "img/metrics.ddcaa36e.png";